import { SignIn } from 'components/containers';

export default function SignInPage() {
  return <SignIn />;
}
